<template>
  <form @keyup.esc="close()" tabindex="0" >
  <v-layout id='map_detail_view' class='map-detail-view' v-resize="onResize" v-if="mapData.detailView.show" :style="{'left': left, 'top': top}">
    <div class="detail-view-wrap">
      <v-flex shrink>
        <div class="view-title-bar">
          <v-layout v-on:mousedown="dragStart" align-center justify-space-between row wrap fill-height>
            <!-- 좌측 -->
            <v-flex class="text-xs-left hidden-md-and-up" shrink>
              <v-btn fit icon @click="close()"><v-icon>keyboard_arrow_left</v-icon></v-btn>
            </v-flex>
            <!-- 타이틀 -->
            <v-flex :class="['text-xs-left', 'title-text', ($vuetify.breakpoint.mdAndUp) ? 'pl-4' : 'pl-1']">
              <span v-if="mapData.detailView.type === 'r'">매물번호 </span><span v-if="mapData.detailView.type === 'b'">건물번호 B</span>{{mapData.detailView.no}}
            </v-flex>
            <!-- 우측 -->
            <v-flex class="text-xs-right hidden-sm-and-down mr-1" shrink>
              <v-btn fit icon @click="toggleFavorite(mapData.detailView.no)" class="mr-3">
                <v-icon size="26" color="#f2412a" v-if="isFavorite(mapData.detailView.no)">favorite</v-icon>
                <v-icon size="26" color="#505050" v-if="!isFavorite(mapData.detailView.no)">favorite_border</v-icon>
              </v-btn>
              <v-btn fit icon @click="urlCopy()"><v-icon size="22" color="#505050">filter_none</v-icon></v-btn>
              <v-btn fit icon @click="urlShare()"><v-icon size="24" color="#505050">share</v-icon></v-btn>
              <v-btn fit icon @click="close()"><v-icon>close</v-icon></v-btn>
            </v-flex>
            <v-flex class="hidden-md-and-up mr-1" shrink>
              <v-btn fit icon @click="toggleFavorite(mapData.detailView.no)" class="mr-2">
                <v-icon size="24" color="#f2412a" v-if="isFavorite(mapData.detailView.no)">favorite</v-icon>
                <v-icon size="24" color="#505050" v-if="!isFavorite(mapData.detailView.no)">favorite_border</v-icon>
              </v-btn>
              <v-btn fit icon @click="urlCopy()" class="mr-0"><v-icon size="20" color="#505050">filter_none</v-icon></v-btn>
              <v-btn fit icon @click="urlShare()"><v-icon size="22" color="#505050">share</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <div class="view-detail">
        <!-- 룸 -->
        <v-layout class="detail-r" v-if="mapData.detailView.type === 'r'" row wrap>

          <v-flex class="detail-carousel">
            <!-- no img -->
            <div v-if="getDetailViewSize === 0" class="no-img" :style="{'line-height' : carouselHeight + 'px', 'height' : carouselHeight + 'px'}"><v-icon>camera_alt</v-icon> 촬영준비중</div>
            <!-- Carousel -->
            <OCarousel v-if="getDetailViewSize !== 0" :items="mapData.detailView.viewList"></OCarousel>
          </v-flex>
          <!-- carousel btn -->
          <!-- notice -->
          <v-flex class="view-notice">
            계약기간, 입주시기에 따라 보증금/월세 조정 가능합니다.
          </v-flex>
          <!-- admin btn -->
          <v-flex class="contents-wrap"  v-if="auth.isStaff">
            <v-btn depressed small v-if="auth.isStaff && !$utile.isMobile()" @click="downThumbImg(mapData.detailView.data.structure_name + '(' + mapData.detailView.data.item_name + ')')">이미지다운</v-btn>
            <v-btn depressed small v-if="auth.isStaff && !$utile.isMobile()" @click="downOriImg(mapData.detailView.data.structure_name + '(' + mapData.detailView.data.item_name + ')')">원본이미지다운</v-btn>
            <router-link :to="{ path: 'map', query: { no: 'b' + mapData.detailView.data.structure_no }}"><v-btn depressed small>건물보기</v-btn></router-link>
            <v-btn depressed small v-if="auth.isManager" class="btn-modif" @click="showModifView('r', mapData.detailView.data.contract_url)">계약등록</v-btn>
            <v-btn depressed small @click="showModifView('r', mapData.detailView.data.modif_url)">매물관리</v-btn>
          </v-flex>
          <!-- contents -->
          <v-flex class="contents-wrap">
            <div class="title-area">
              <div class="item-state" v-if="(auth.isStaff && mapData.detailView.data.visible === '1') || mapData.detailView.data.live === '1'" ><span class="box-visible" v-if="auth.isStaff && mapData.detailView.data.visible === '1'">광고중</span><span class="box-live" v-if="mapData.detailView.data.live === '1'">공실매물</span></div>
              <div class="item-title">
                {{mapData.detailView.data.price}}
              </div>
              <v-layout class="pictogram-area">
                <v-flex class="item" xs3>
                  <div><img :src="getStaticUrl() + '/map/detail/r-struct.svg'"/></div>
                  <div class="label">{{mapData.detailView.data.itemType + '/' + mapData.detailView.data.struct}}</div>
                </v-flex>
                <v-flex class="item" xs3>
                  <div><img :src="getStaticUrl() + '/map/detail/r-floor.svg'"/></div>
                  <div class="label">{{mapData.detailView.data.floor + '/'+ mapData.detailView.data.structureHeight + '층'}}</div>
                </v-flex>
                <v-flex class="item" xs3>
                  <div><img :src="getStaticUrl() + '/map/detail/r-receipt.svg'"/></div>
                  <div class="label">관리비 {{mapData.detailView.data.mCost}}</div>
                </v-flex>
                <v-flex class="item" xs3>
                  <div><img :src="getStaticUrl() + '/map/detail/r-date.svg'"/></div>
                  <div class="label">{{mapData.detailView.data.approvalDate}}</div>
                </v-flex>
              </v-layout>
              <div class="tag-area" v-if="mapData.detailView.data.tags.length > 0">
                <div v-if="mapData.detailView.data.tags.length > 0 && tag !== ''" v-for="tag in mapData.detailView.data.tags" :key="tag" class="tag">
                  #{{tag}}
                </div>
              </div>
            </div>
          </v-flex>
          <!-- 관리 정보 -->
          <v-flex class="contents-wrap" v-if="auth.isStaff">
            <div v-if="mapData.detailView.data.tel.length > 0" class="mb-2">
              <div class="contents-title title-point">
                연락처
              </div>
              <v-flex class="info-table" row wrap>
                <v-layout v-for="(telinfo, index) in mapData.detailView.data.tel" :key="index" class="info-tr">
                  <v-flex class="info-title" xs4>
                    연락처
                  </v-flex>
                  <v-flex class="info-value" xs8>
                    {{telinfo}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
            <div class="mb-2">
              <div class="contents-title title-point">
                정보
              </div>
              <v-flex class="info-table" row wrap>
                <v-layout class="info-tr">
                  <v-flex class="info-title" xs4>
                    건물명/호수
                  </v-flex>
                  <v-flex class="info-value" xs8>
                    {{mapData.detailView.data.structure_name + '(' + mapData.detailView.data.item_name + ')'}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
            <!-- 중복 연락처 -->
            <div v-if="(auth.isStaff || auth.isPartner) && mapData.detailView.data.overlap_tel.length > 0" class="mb-2">
              <div class="contents-title title-point">
                연락처중복
              </div>
              <v-flex class="info-table" row wrap>
                <v-layout v-for="(values, index) in mapData.detailView.data.overlap_tel" :key="index" class="info-tr">
                  <v-flex class="info-title" xs4>
                    <div v-if="values.img_url !== ''">
                      <img :src="values.img_url">
                    </div>
                    <div v-if="values.img_url === ''">
                      사진미등록
                    </div>
                  </v-flex>
                  <v-flex class="info-value" xs8>
                    <span class="point">{{`${values.tel} ${values.info}`}}</span><br>
                    {{(values.type == 1) ? '[건물]' : '[매물]'}} {{values.name}} - {{values.addr}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
          </v-flex>
          <!-- 가격 -->
          <v-flex class="contents-wrap">
            <div class="contents-title">
              가격
            </div>
            <v-flex class="info-table" row wrap>
              <v-layout class="info-tr" v-if="mapData.detailView.data.monthly.length > 0">
                <v-flex class="info-title" xs4>
                  보증금/월세
                </v-flex>
                <v-flex class="info-value" xs8>
                  <div v-for="(item, index) in mapData.detailView.data.monthly" :key="index" class="mb-1">
                    {{item.deposit + '/' + item.monthly}}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout class="info-tr" v-if="mapData.detailView.data.salePrice !== '' && parseInt(mapData.detailView.data.salePrice) > 0">
                <v-flex class="info-title" xs4>
                  전세
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.salePrice}}만 원
                </v-flex>
              </v-layout>
              <v-layout class="info-tr" v-if="mapData.detailView.data.saleType === '2' && mapData.detailView.data.salePrice !== ''">
                <v-flex class="info-title" xs4>
                  매매가
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.salePrice}}만 원
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  관리비
                </v-flex>
                <v-flex class="info-value" xs8>
                  <div>{{getMTypeText(mapData.detailView.data.mType)}} {{mapData.detailView.data.mCost}}</div>
                  <div>{{mapData.detailView.data.mOpt}}</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>

          <!-- 정보 -->
          <v-flex class="contents-wrap">
            <div class="contents-title">
              정보
            </div>
            <v-flex class="info-table" row wrap>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  방종류
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.itemType + '(' + mapData.detailView.data.struct + ')'}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  해당층/건물층
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.floor + ' / '+ mapData.detailView.data.structureHeight + '층'}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  주소
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.addr}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  난방종류
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.heatingType}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  주인세대
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.owner_room}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  관리실
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.m_room}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  엘리베이터
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.elevator}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  CCTV
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.cctv}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  주차
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.parking}}대
                </v-flex>
              </v-layout>
              <v-layout class="info-tr" v-if="mapData.detailView.data.balcony == '1'">
                <v-flex class="info-title" xs4>
                  발코니
                </v-flex>
                <v-flex class="info-value" xs8>
                  있음
                </v-flex>
              </v-layout>
              <v-layout class="info-tr" v-if="mapData.detailView.data.built_in == '1'">
                <v-flex class="info-title" xs4>
                  빌트인
                </v-flex>
                <v-flex class="info-value" xs8>
                  있음
                </v-flex>
              </v-layout>
              <v-layout class="info-tr" v-if="mapData.detailView.data.pet == '1'">
                <v-flex class="info-title" xs4>
                  애완동물
                </v-flex>
                <v-flex class="info-value" xs8>
                  가능
                </v-flex>
              </v-layout>
              <v-layout class="info-tr" v-if="mapData.detailView.data.loan == '1'">
                <v-flex class="info-title" xs4>
                  전세자금대출
                </v-flex>
                <v-flex class="info-value" xs8>
                  가능
                </v-flex>
              </v-layout>
              <v-layout class="info-tr" v-if="mapData.detailView.data.non_option == '1'">
                <v-flex class="info-title" xs4>
                  옵션
                </v-flex>
                <v-flex class="info-value" xs8>
                  비옵션주택
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>

          <!-- 옵션 -->
          <v-flex class="contents-wrap">
            <div class="contents-title">
              옵션
            </div>
            <v-layout class="opt-area" row wrap>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_1 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-bed.svg'"/></div>
                <div class="label">침대</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_2 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-desk.svg'"/></div>
                <div class="label">책상</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_3 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-closet.svg'"/></div>
                <div class="label">옷장</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_4 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-shose.svg'"/></div>
                <div class="label">신발장</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_5 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-tv.svg'"/></div>
                <div class="label">TV</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_6 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-aircon.svg'"/></div>
                <div class="label">에어컨</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_7 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-washer.svg'"/></div>
                <div class="label">세탁기</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_8 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-refrigerator.svg'"/></div>
                <div class="label">냉장고</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_9 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-stove.svg'"/></div>
                <div class="label">가스레인지</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_10 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-induction.svg'"/></div>
                <div class="label">인덕션</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_11 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-microwave.svg'"/></div>
                <div class="label">전자레인지</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_12 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-bidet.svg'"/></div>
                <div class="label">비데</div>
              </v-flex>
              <v-flex class="item" xs3 sm2 v-if="mapData.detailView.data.itemOpt.r_opt_13 === '1'">
                <div><img :src="getStaticUrl() + '/map/detail/r-opt-doorlock.svg'"/></div>
                <div class="label">전자도어락</div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 건물 상세 시작 -->
        <v-layout class="detail-b" v-if="mapData.detailView.type === 'b'" row wrap>
          <v-flex class="detail-carousel" :height="carouselHeight">
            <div v-if="mapData.detailView.data.imgStructureCount === '0'" class="no-img" :style="{'line-height' : carouselHeight + 'px', 'height' : carouselHeight + 'px'}"><v-icon>camera_alt</v-icon> 촬영준비중</div>
            <v-carousel hide-delimiters :height="carouselHeight" v-if="mapData.detailView.data.imgStructureCount !== '0'">
              <v-carousel-item
                v-for="(item,i) in mapData.detailView.data.imgStructureArray"
                :key="i"
                :src="item.src"
              >
              </v-carousel-item>
            </v-carousel>
          </v-flex>
          <v-flex class="view-notice">
            방문하시면, 호수별로 실사진을 보실수 있습니다.
          </v-flex>
          <!-- admin btn -->
          <v-flex class="contents-wrap"  v-if="auth.isStaff">
            <v-btn depressed small v-if="auth.isManager && !$utile.isMobile()" @click="downThumbImg(mapData.detailView.data.name)">이미지다운</v-btn>
            <v-btn depressed small v-if="auth.isAdmin && !$utile.isMobile()" @click="downOriImg(mapData.detailView.data.name)">원본이미지다운</v-btn>
            <v-btn depressed small @click="showModifView('b', mapData.detailView.data.modif_url)">건물관리</v-btn>
          </v-flex>
          <!-- 타이틀 정보 -->
          <v-flex class="contents-wrap">
            <div class="title-area">
              <div class="item-state" v-if="auth.isStaff && (mapData.detailView.data.visible === '1' || mapData.detailView.data.black_list === '1')" ><span class="box-visible" v-if="mapData.detailView.data.visible === '1'">광고중</span><span class="box-blacklist" v-if="mapData.detailView.data.black_list === '1'">블랙리스트</span></div>
              <div class="item-title">
                {{mapData.detailView.data.name}}
              </div>
              <v-layout class="pictogram-area">
                <v-flex class="item" xs3>
                  <div><img :src="getStaticUrl() + '/map/detail/s-use.svg'"/></div>
                  <div class="label">{{mapData.detailView.data.struct_use}}</div>
                </v-flex>
                <v-flex class="item" xs3>
                  <div><img :src="getStaticUrl() + '/map/detail/s-landuse.svg'"/></div>
                  <div class="label">{{mapData.detailView.data.land_use}}</div>
                </v-flex>
                <v-flex class="item" xs3>
                  <div><img :src="getStaticUrl() + '/map/detail/s-floor.svg'"/></div>
                  <div class="label">{{mapData.detailView.data.floor + '층'}}</div>
                </v-flex>
                <v-flex class="item" xs3>
                  <div><img :src="getStaticUrl() + '/map/detail/s-date.svg'"/></div>
                  <div class="label">{{mapData.detailView.data.approvalDate}}</div>
                </v-flex>
              </v-layout>
              <div class="tag-area" v-if="mapData.detailView.data.tags.length > 0">
                <div v-if="mapData.detailView.data.tags.length > 0 && tag !== ''" v-for="tag in mapData.detailView.data.tags" :key="tag" class="tag">
                  #{{tag}}
                </div>
              </div>
            </div>
          </v-flex>

          <!-- 관리 정보 -->
          <v-flex class="contents-wrap" v-if="auth.isStaff || auth.isPlusMember || auth.isPartner">
            <div v-if="(auth.isStaff || auth.isPartner) && mapData.detailView.data.tel.length > 0" class="mb-2">
              <div class="contents-title title-point">
                연락처
              </div>
              <v-flex class="info-table" row wrap>
                <v-layout v-for="(telinfo, index) in mapData.detailView.data.tel" :key="index" class="info-tr">
                  <v-flex class="info-title" xs4>
                    연락처
                  </v-flex>
                  <v-flex class="info-value" xs8>
                    {{telinfo}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
            <div v-if="(auth.isStaff || auth.isPartner) && mapData.detailView.data.memo != ''" class="mb-2">
              <div class="contents-title title-point">
                메모사항
              </div>
              <v-flex class="info-table" row wrap>
                <v-layout class="info-tr">
                  <v-flex class="info-title" xs4>
                    메모
                  </v-flex>
                  <v-flex class="info-value" xs8>
                    {{mapData.detailView.data.memo}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
            <div>
              <v-layout class="contents-title title-point mt-2 justify-space-between">
                <v-flex class="grow">매물현황</v-flex>
                <v-flex class="shrink">
                  <v-switch
                    v-model="b.itemModif"
                    :label="`수정`"
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <div>
                <v-flex class="info-table" row wrap>
                  <v-layout v-if="items != null && items.length > 0" v-for="(items, floor, index1) in mapData.detailView.data.items" :key="index1" class="info-tr">
                    <v-flex class="info-title" xs4>
                      {{floor.replace('F', '지상 ').replace('R', '옥탑 ').replace('B', '지하 ') + '층'}}{{(items[0].half_floor === '1') ? '(반지층)' : ''}}
                    </v-flex>
                    <v-flex class="info-value info-items" xs8>
                      <div v-for="(item, index2) in items" :key="index2" :class="getItemClass(item)" v-if="b.itemModif" @click="showModifView('r', `${$utile.getBaseUrl()}/rep/pro/page/item/for_item?hl=2&hsi=1&no=${item.no}`)">
                        {{item.name}}
                      </div>
                      <router-link tag="div" :to="{ path: 'map', query: { no: 'r' + item.no }}" v-for="(item, index2) in items" :key="index2" :class="getItemClass(item)"  v-if="!b.itemModif">
                        {{item.name}}
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </div>
            </div>
            <!-- 매물 연락처 -->
            <div v-if="(auth.isStaff || auth.isPartner) && mapData.detailView.data.item_tel.length > 0" class="mb-2">
              <div class="contents-title title-point">
                매물별 연락처
              </div>
              <v-flex class="info-table" row wrap>
                <router-link v-for="(values, index) in mapData.detailView.data.item_tel" :key="index" class="layout info-tr" tag="div" :to="{ path: 'map', query: { no: 'r' + values.no }}" style="cursor: pointer;">
                  <v-flex class="info-title" xs4>
                    <p class="point">{{values.name}}</p>
                  </v-flex>
                  <v-flex class="info-value" xs8>
                    <p>{{values.tel}} - {{values.info}}</p>
                  </v-flex>
                </router-link>
              </v-flex>
            </div>
            <!-- 중복 연락처 -->
            <div v-if="(auth.isStaff || auth.isPartner) && mapData.detailView.data.overlap_tel.length > 0" class="mb-2 mt-2">
              <div class="contents-title title-point">
                연락처중복
              </div>
              <v-flex class="info-table" row wrap>
                <router-link v-for="(values, index) in mapData.detailView.data.overlap_tel" :key="index" class="layout info-tr" tag="div" :to="{ path: 'map', query: { no: ((values.type == 1) ? 'b' : 'r') + values.no }}" style="cursor: pointer;">
                  <v-flex class="info-title" xs4>
                    <div v-if="values.img_url !== ''">
                      <img :src="values.img_url">
                    </div>
                    <div v-if="values.img_url === ''">
                      사진미등록
                    </div>
                  </v-flex>
                  <v-flex class="info-value" xs8>
                    <span class="point">{{`${values.tel} ${values.info}`}}</span><br>
                    {{(values.type == 1) ? '[건물]' : '[매물]'}} {{values.name}} - {{values.addr}}
                  </v-flex>
                </router-link>
              </v-flex>
            </div>
          </v-flex>

          <!-- 정보 -->
          <v-flex class="contents-wrap">
            <div class="contents-title">
              <span>정보</span>
              <v-btn outline small round color="title_dark1" class="right ma-0" style="margin-top:1px !important;" @click="structureInfo(mapData.detailView.no, mapData.detailView.data.bcode, mapData.detailView.data.addr)">건축물대장 조회</v-btn>
            </div>
            <v-flex class="info-table" row wrap>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  건물명
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.name}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  준공년도
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.approvalDate}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  지번주소
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.addr}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  도로명
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.road_addr}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  세대수
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.item_count}}세대
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  전체층수
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{printTotalFloor()}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  주용도
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.struct_use}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  용도지역
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.land_use}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  주인세대
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.owner_room}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  관리실
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.m_room}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  엘리베이터
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.elevator}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  CCTV
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.cctv}}
                </v-flex>
              </v-layout>
              <v-layout class="info-tr">
                <v-flex class="info-title" xs4>
                  주차
                </v-flex>
                <v-flex class="info-value" xs8>
                  {{mapData.detailView.data.parking}}대
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>

        </v-layout>
        <!-- 지도 -->
        <v-flex class="contents-wrap">
          <div class="contents-title">
            위치
          </div>
          <div class="mini-map">
            <div class="btn-road-view" :class="map.mapTypeId === 5 ? 'active-btn': ''" @click="setOverlayMapTypeId(5)">로드뷰</div>
            <v-flex class="mini-roadview-area" :style="map.roadviewArea?'display:block;':'display:none;'">
              <div class="btn-road-view" @click="map.roadviewArea = false" >
                닫기
              </div>
              <div id="mini_roadview_area"></div>
            </v-flex>
            <mini-map ref="minimap"
                      :appKey="map.appKey"

                      :center="map.center"
                      :level="map.level"
                      :mapTypeId.sync="map.mapTypeId"
                      :libraries="map.libraries"

                      @load="onLoad"
                      @zoom_start="onMapEvent('zoom_start', $event)"
                      @zoom_changed="onMapEvent('zoom_changed', $event)"
                      @click="onMapEvent('click', $event)"
                      @dblclick="onMapEvent('dblclick', $event)"
                      @rightclick="onMapEvent('rightclick', $event)"
                      @dragstart="onMapEvent('dragstart', $event)"
                      @dragend="onMapEvent('dragend', $event)"
                      @idle="onMapEvent('idle', $event)"
                      @maptypeid_changed="onMapEvent('maptypeid_changed', $event)"

                      style="position:relative; height: 100%;">
            </mini-map>
          </div>
        </v-flex>
      </div>
      <!-- 하단 바 -->
      <v-flex shrink  v-if="mapData.detailView.type === 'r'">
        <div class="view-bottom-bar">
          <v-layout class="bar-wrap" justify-center fill-height>
            <v-flex class="item" @click="findRoom(mapData.detailView.no)"><v-icon class="icon">sms</v-icon><span>예약상담</span></v-flex>
            <v-flex class="item" v-if="$utile.isMobile()" @click="callcenter()" style="border-left:solid 1px #69a6ff;"><v-icon class="icon">phone</v-icon><span>전화상담</span></v-flex>
          </v-layout>
        </div>
      </v-flex>
    </div>
    <!-- 전화상담 정보 모달-->
    <v-dialog
      v-model="telInfoDialog"
      width="300"
    >

      <v-card>
        <div class="pa-3">
          <v-icon size="28" class="icon" style="color:#303030;">phone</v-icon> <span class="ml-2" style="font-size: 20px; color:#303030; font-weight: 500;">전화상담</span>
        </div>
        <v-divider></v-divider>

        <v-card-text>
          <div class="item-info text-xs-center my-3">
            <span class="headline" style="font-size: 28px !important;"><strong><a :href="'tel:' + config.company.customerNumber" class="text-point">{{config.company.customerNumber}}</a></strong></span><br>
            <span  style="font-size: 16.4px !important;">{{config.company.customerTime}}</span>
          </div>
          <div class="item-info text-xs-center my-3">
            <span>친절하게 고객님께 딱 맞는 방을 찾아드릴 상담원이 대기중입니다.</span>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="telInfoDialog = false"
          >
            닫기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 건축물대장 조회 모달-->
    <v-dialog
      v-model="structureInfoDialog"
      width="420"
    >

      <v-card>

        <div class="pa-3">
          <span style="font-size: 20px; color:#303030; font-weight: 500;"><v-icon style="color:#303030;">reorder</v-icon> 건축물대장 층별개요</span>
        </div>
        <v-divider></v-divider>

        <v-card-text v-html="structureFloorInfoStr">
        </v-card-text>

        <v-divider></v-divider>
        <div class="pa-3">
          <span style="font-size: 20px; color:#303030; font-weight: 500;"><v-icon style="color:#303030;">business</v-icon> 건축물대장 표제부</span>
        </div>
        <v-divider></v-divider>

        <v-card-text v-html="structureInfoStr">
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="structureInfoDialog = false"
          >
            닫기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  </form>
</template>

<script>
import EventBus from '@/utile/eventBus'
import MiniMap from '../../plugin/KakaoMap'
import Utile from '@/utile/utile'

import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

import loadScriptOnce from 'load-script-once'

import axios from 'axios'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import OCarousel from '@/components/plugin/carousel/OCarousel'

// 압축 다운로드
const getFile = url => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      responseType: 'arraybuffer'
    }).then(data => {
      resolve(data.data)
    }).catch(error => {
      reject(error.toString())
    })
  })
}

const downloadObjectAsZip = (type, savename, urlArray) => {
  let info = savename
  info = info.replace(/\s/gi, '')
  info = info.replace(/[~!#$^&*=+|:;?"<,.>']/, '')
  const zip = new JSZip()
  const cache = {}
  const promises = []
  urlArray.forEach((item, index) => {
    const promise = getFile(item).then(data => {
      // const arrname = item.split('/')
      // const filename = arrname[arrname.length - 1]
      const ext = item.split('.')
      const filename = index + '.' + ext[ext.length - 1]
      zip.file(filename, data, { binary: true })
      cache[filename] = data
    })
    promises.push(promise)
  })
  Promise.all(promises).then(() => {
    zip.generateAsync({type: 'blob'}).then(content => {
      FileSaver.saveAs(content, 'imgs.' + type + '.' + info + '.zip')
    })
  })
}

export default {
  name: 'DetailView',
  data: () => ({
    // 맵
    map: {
      appKey: '',
      center: { lat: 37.4803073, lng: 126.9328443 },
      level: 3, // 기본 3
      mapTypeId: MiniMap.MapTypeId.NORMAL,
      libraries: [ 'services' ],
      mapObject: null,
      roadviewArea: false,
      polygon: null
    },
    // 뷰
    drag: false,
    viewElement: null,
    currentX: 0,
    currentY: 0,
    initialX: 0,
    initialY: 0,
    xOffset: 0,
    yOffset: 0,
    top: 0,
    left: 0,
    isMobile: Utile.isMobile(),
    carouselHeight: 0,
    r: {
      carouselType: 'all' // all, item, 2d, 3d, vr
    },
    b: {
      itemModif: false
    },
    // 카카오
    Kakao: null,
    // 전화상담 모달
    telInfoDialog: false,
    // 건축물대장 조회 모달
    structureInfoDialog: false,
    structureInfoStr: '',
    structureFloorInfoStr: ''
  }),
  components: {
    OCarousel,
    MiniMap
  },
  computed: {
    ...mapState({
      mapData: state => state.mapData,
      auth: state => state.auth,
      config: state => state.config
    }),
    ...mapGetters({
      getDetailViewList: 'mapData/getDetailViewList',
      getDetailViewSize: 'mapData/getDetailViewSize',
      isFavorite: 'mapData/isFavorite'
    })
  },
  created () {
    this.map.appKey = this.config.kakaRestApiAppKey
  },
  mounted () {
    this.$store.watch(() => this.$store.state.mapData.detailView.data, (newValue, oldValue) => {
      this.$refs.minimap.init()
      this.drowPolygon()
    })
    loadScriptOnce(`//developers.kakao.com/sdk/js/kakao.min.js`, (err) => {
      if (err) {
        console.error(err)
        return
      }
      /* global Kakao */
      this.Kakao = Kakao
      this.Kakao.init(this.config.kakaJavascriptApiAppKey)
    })
  },
  methods: {
    ...mapMutations({
      setDetailViewMode: 'mapData/setDetailViewMode'
    }),
    ...mapActions({
      toggleFavorite: 'mapData/toggleFavorite',
      requestMapData: 'mapData/requestMapData'
    }),
    getMTypeText (mtype) {
      if (mtype === '1') {
        return '순수관리비'
      } else if (mtype === '2') {
        return '평당관리비'
      }
      return ''
    },
    requestData (url) {
      return new Promise((resolve, reject) => {
        axios.get(Utile.getRestUrl() + url).then(result => {
          // 어레이 반환
          resolve(result.data)
        }, error => {
          reject(error)
        })
      })
    },
    bunjispace (val) {
      var str = val
      var strlen = str.length
      for (var i = 0; i < (4 - strlen); i++) {
        str = '0' + str
      }
      return str
    },
    structure_table (title, array) {
      let _this = this
      let str = '<div class="structure-info-table clearfix">' +
        '<div class="table-title">' + title + '</div>' +
        '<div class="table-tr clearfix"><div class="table-th">항목</div><div class="table-th">정보</div></div>'

      const printArray = [ 'mgmBldrgstPk', 'regstrGbCdNm', 'regstrKindCdNm', 'bldNm', 'platPlc', 'newPlatPlc', 'roofCdNm', 'strctCdNm', 'mainPurpsCdNm', 'mainAtchGbCdNm', 'rideUseElvtCnt', 'emgenUseElvtCnt', 'fmlyCnt', 'hhldCnt', 'hoCnt', 'grndFlrCnt', 'ugrndFlrCnt', 'heit', 'oudrAutoArea', 'oudrAutoUtcnt', 'oudrMechArea', 'oudrMechUtcnt', 'archArea', 'platArea', 'totArea', 'totDongTotArea', 'vlRat', 'vlRatEstmTotArea', 'pmsDay', 'stcnsDay', 'useAprDay', 'crtnDay' ]
      printArray.forEach(function (item, index) {
        str += '<div class="table-tr clearfix"><div class="table-td"><p>' + _this.getStructureCodeName(item) + '</p></div><div class="table-td"><span><p>' + array[item] + '</p></span></div></div>'
      })
      str += '</div>'
      return str
    },
    structure_floor_table (title, array) {
      let _this = this
      let str = '<div class="structure-info-table clearfix">' +
        '<div class="table-title">' + title + '</div>' +
        '<div class="table-tr clearfix"><div class="table-th">항목</div><div class="table-th">정보</div></div>'

      const printArray = [ 'flrGbCdNm', 'flrNoNm', 'area', 'mainPurpsCdNm', 'etcPurps' ]
      printArray.forEach(function (item, index) {
        str += '<div class="table-tr clearfix"><div class="table-td"><p>' + _this.getStructureFloorCodeName(item) + '</p></div><div class="table-td"><span><p>' + array[item] + '</p></span></div></div>'
      })
      str += '</div>'
      return str
    },
    // 건축물대장 조회
    structureInfo (no, bcode, addr) {
      var sigunguCd = bcode.substr(0, 5)
      var bjdongCd = bcode.substr(5, 5)
      var bunjiArray = addr.split(' ')
      var bunji = bunjiArray[bunjiArray.length - 1]
      var bun = bunji.split('-')[0]
      var ji = bunji.split('-')[1]

      if (bun === undefined) bun = '0000'
      if (ji === undefined) ji = '0000'

      bun = this.bunjispace(bun)
      ji = this.bunjispace(ji)

      // 층별
      this.structureFloorInfoStr = ''

      this.requestData(`/structure.api?type=4&sigunguCd=${encodeURIComponent(String(sigunguCd))}&bjdongCd=${encodeURIComponent(String(bjdongCd))}&bun=${encodeURIComponent(String(bun))}&ji=${encodeURIComponent(String(ji))}`).then((data) => {
        var structureInfoCount = data['totalCount']
        if (structureInfoCount === 1) {
          let title = ''
          let array = data['items']['item']
          if (array['flrGbCdNm'] && array['flrGbCdNm'] !== undefined) {
            title = array['flrGbCdNm']
          }
          if (array['flrNoNm'] && array['flrNoNm'] !== undefined) {
            title = `${title} ${array['flrNoNm']}`
          }
          this.structureFloorInfoStr += this.structure_floor_table(title, array)
        } else if (structureInfoCount > 1) {
          data['items']['item'].sort(function (a, b) { // 오름차순 층별 정렬
            return (b['flrGbCd'] - a['flrGbCd']) || (b['flrNo'] - a['flrNo'])
          })
          for (var j = 0; j < structureInfoCount; j++) {
            if (data['items']['item'][j]) {
              let title = ''
              let array = data['items']['item'][j]
              if (array['flrGbCdNm'] && array['flrGbCdNm'] !== undefined) {
                title = array['flrGbCdNm']
              }
              if (array['flrNoNm'] && array['flrNoNm'] !== undefined) {
                title = `${title} ${array['flrNoNm']}`
              }
              this.structureFloorInfoStr += this.structure_floor_table(title, array)
            }
          }
        }
        if (this.structureFloorInfoStr === '') {
          this.structureFloorInfoStr = '건축물대장 층별 정보를 조회하지 못하였습니다.'
        }
      })

      // 표제부
      this.structureInfoStr = ''

      this.requestData(`/structure.api?type=3&sigunguCd=${encodeURIComponent(String(sigunguCd))}&bjdongCd=${encodeURIComponent(String(bjdongCd))}&bun=${encodeURIComponent(String(bun))}&ji=${encodeURIComponent(String(ji))}`).then((data) => {
        var structureInfoCount = data['totalCount']
        if (structureInfoCount === 1) {
          let title = ''
          let array = data['items']['item']
          if (array['bldNm'] && array['bldNm'] !== undefined) {
            title = array['bldNm']
          }
          this.structureInfoStr += this.structure_table(title, array)
        } else if (structureInfoCount > 1) {
          for (var j = 0; j < structureInfoCount; j++) {
            if (data['items']['item'][j]) {
              let title = ''
              let array = data['items']['item'][j]
              if (array['bldNm'] && array['bldNm'] !== undefined) {
                title = array['bldNm']
              }
              this.structureInfoStr += this.structure_table(title, array)
            }
          }
        }
        if (this.structureInfoStr === '') {
          this.structureInfoStr = '건축물대장 정보를 조회하지 못하였습니다.'
        }
      })

      this.structureInfoDialog = true
    },
    // 건축물대장 표제부 이름반환
    getStructureCodeName (code) {
      if (code === 'mainPurpsCdNm') { return '주용도코드명' } else if (code === 'etcPurps') { return '기타용도' } else if (code === 'roofCd') { return '지붕코드' } else if (code === 'roofCdNm') { return '지붕코드명' } else if (code === 'etcRoof') { return '기타지붕' } else if (code === 'hhldCnt') { return '세대수(세대)' } else if (code === 'fmlyCnt') { return '가구수(가구)' } else if (code === 'heit') { return '높이(m)' } else if (code === 'grndFlrCnt') { return '지상층수' } else if (code === 'ugrndFlrCnt') { return '지하층수' } else if (code === 'rideUseElvtCnt') { return '승용승강기수' } else if (code === 'emgenUseElvtCnt') { return '비상용승강기수' } else if (code === 'atchBldCnt') { return '부속건축물수' } else if (code === 'atchBldArea') { return '부속건축물면적(㎡)' } else if (code === 'totDongTotArea') { return '총동연면적(㎡)' } else if (code === 'indrMechUtcnt') { return '옥내기계식대수(대)' } else if (code === 'indrMechArea') { return '옥내기계식면적(㎡)' } else if (code === 'oudrMechUtcnt') { return '옥외기계식대수(대)' } else if (code === 'oudrMechArea') { return '옥외기계식면적(㎡)' } else if (code === 'indrAutoUtcnt') { return '옥내자주식대수(대)' } else if (code === 'indrAutoArea') { return '옥내자주식면적(㎡)' } else if (code === 'oudrAutoUtcnt') { return '옥외자주식대수(대)' } else if (code === 'oudrAutoArea') { return '옥외자주식면적(㎡)' } else if (code === 'pmsDay') { return '허가일' } else if (code === 'stcnsDay') { return '착공일' } else if (code === 'useAprDay') { return '사용승인일' } else if (code === 'pmsnoYear') { return '허가번호년' } else if (code === 'pmsnoKikCd') { return '허가번호기관코드' } else if (code === 'pmsnoKikCdNm') { return '허가번호기관코드명' } else if (code === 'pmsnoGbCd') { return '허가번호구분코드' } else if (code === 'pmsnoGbCdNm') { return '허가번호구분코드명' } else if (code === 'hoCnt') { return '호수(호)' } else if (code === 'engrGrade') { return '에너지효율등급' } else if (code === 'engrRat') { return '에너지절감율' } else if (code === 'engrEpi') { return 'EPI점수' } else if (code === 'gnBldGrade') { return '친환경건축물등급' } else if (code === 'gnBldCert') { return '친환경건축물인증점수' } else if (code === 'itgBldGrade') { return '지능형건축물등급' } else if (code === 'itgBldCert') { return '지능형건축물인증점수' } else if (code === 'crtnDay') { return '생성일자' } else if (code === 'rnum') { return '순번' } else if (code === 'platPlc') { return '대지위치' } else if (code === 'sigunguCd') { return '시군구코드' } else if (code === 'bjdongCd') { return '법정동코드' } else if (code === 'platGbCd') { return '대지구분코드' } else if (code === 'bun') { return '번' } else if (code === 'ji') { return '지' } else if (code === 'mgmBldrgstPk') { return '관리건축물대장PK' } else if (code === 'regstrGbCd') { return '대장구분코드' } else if (code === 'regstrGbCdNm') { return '대장구분코드명' } else if (code === 'regstrKindCd') { return '대장종류코드' } else if (code === 'regstrKindCdNm') { return '대장종류코드명' } else if (code === 'newPlatPlc') { return '도로명대지위치' } else if (code === 'bldNm') { return '건물명' } else if (code === 'splotNm') { return '특수지명' } else if (code === 'block') { return '블록' } else if (code === 'lot') { return '로트' } else if (code === 'bylotCnt') { return '외필지수' } else if (code === 'naRoadCd') { return '새주소도로코드' } else if (code === 'naBjdongCd') { return '새주소법정동코드' } else if (code === 'naUgrndCd') { return '새주소지상지하코드' } else if (code === 'naMainBun') { return '새주소본번' } else if (code === 'naSubBun') { return '새주소부번' } else if (code === 'dongNm') { return '동명칭' } else if (code === 'mainAtchGbCd') { return '주부속구분코드' } else if (code === 'mainAtchGbCdNm') { return '주부속구분코드명' } else if (code === 'platArea') { return '대지면적(㎡)' } else if (code === 'archArea') { return '건축면적(㎡)' } else if (code === 'bcRat') { return '건폐율(%)' } else if (code === 'totArea') { return '연면적(㎡)' } else if (code === 'vlRatEstmTotArea') { return '용적률산정연면적(㎡)' } else if (code === 'vlRat') { return '용적률(%)' } else if (code === 'strctCd') { return '구조코드' } else if (code === 'strctCdNm') { return '구조코드명' } else if (code === 'etcStrct') { return '기타구조' } else if (code === 'mainPurpsCd') { return '주용도코드' }
      return '코드미등록'
    },
    /*
    getStructureCodeName (code) {
      if (code === 'mainPurpsCdNm') { return '주용도코드명' } else if (code === 'etcPurps') { return '기타용도' } else if (code === 'roofCd') { return '지붕코드' } else if (code === 'roofCdNm') { return '지붕코드명' } else if (code === 'etcRoof') { return '기타지붕' } else if (code === 'hhldCnt') { return '세대수(세대)' } else if (code === 'fmlyCnt') { return '가구수(가구)' } else if (code === 'heit') { return '높이(m)' } else if (code === 'grndFlrCnt') { return '지상층수' } else if (code === 'ugrndFlrCnt') { return '지하층수' } else if (code === 'rideUseElvtCnt') { return '승용승강기수' } else if (code === 'emgenUseElvtCnt') { return '비상용승강기수' } else if (code === 'atchBldCnt') { return '부속건축물수' } else if (code === 'atchBldArea') { return '부속건축물면적(㎡)' } else if (code === 'totDongTotArea') { return '총동연면적(㎡)' } else if (code === 'indrMechUtcnt') { return '옥내기계식대수(대)' } else if (code === 'indrMechArea') { return '옥내기계식면적(㎡)' } else if (code === 'oudrMechUtcnt') { return '옥외기계식대수(대)' } else if (code === 'oudrMechArea') { return '옥외기계식면적(㎡)' } else if (code === 'indrAutoUtcnt') { return '옥내자주식대수(대)' } else if (code === 'indrAutoArea') { return '옥내자주식면적(㎡)' } else if (code === 'oudrAutoUtcnt') { return '옥외자주식대수(대)' } else if (code === 'oudrAutoArea') { return '옥외자주식면적(㎡)' } else if (code === 'pmsDay') { return '허가일' } else if (code === 'stcnsDay') { return '착공일' } else if (code === 'useAprDay') { return '사용승인일' } else if (code === 'pmsnoYear') { return '허가번호년' } else if (code === 'pmsnoKikCd') { return '허가번호기관코드' } else if (code === 'pmsnoKikCdNm') { return '허가번호기관코드명' } else if (code === 'pmsnoGbCd') { return '허가번호구분코드' } else if (code === 'pmsnoGbCdNm') { return '허가번호구분코드명' } else if (code === 'hoCnt') { return '호수(호)' } else if (code === 'engrGrade') { return '에너지효율등급' } else if (code === 'engrRat') { return '에너지절감율' } else if (code === 'engrEpi') { return 'EPI점수' } else if (code === 'gnBldGrade') { return '친환경건축물등급' } else if (code === 'gnBldCert') { return '친환경건축물인증점수' } else if (code === 'itgBldGrade') { return '지능형건축물등급' } else if (code === 'itgBldCert') { return '지능형건축물인증점수' } else if (code === 'crtnDay') { return '생성일자' } else if (code === 'rnum') { return '순번' } else if (code === 'platPlc') { return '대지위치' } else if (code === 'sigunguCd') { return '시군구코드' } else if (code === 'bjdongCd') { return '법정동코드' } else if (code === 'platGbCd') { return '대지구분코드' } else if (code === 'bun') { return '번' } else if (code === 'ji') { return '지' } else if (code === 'mgmBldrgstPk') { return '관리건축물대장PK' } else if (code === 'regstrGbCd') { return '대장구분코드' } else if (code === 'regstrGbCdNm') { return '대장구분코드명' } else if (code === 'regstrKindCd') { return '대장종류코드' } else if (code === 'regstrKindCdNm') { return '대장종류코드명' } else if (code === 'newPlatPlc') { return '도로명대지위치' } else if (code === 'bldNm') { return '건물명' } else if (code === 'splotNm') { return '특수지명' } else if (code === 'block') { return '블록' } else if (code === 'lot') { return '로트' } else if (code === 'bylotCnt') { return '외필지수' } else if (code === 'naRoadCd') { return '새주소도로코드' } else if (code === 'naBjdongCd') { return '새주소법정동코드' } else if (code === 'naUgrndCd') { return '새주소지상지하코드' } else if (code === 'naMainBun') { return '새주소본번' } else if (code === 'naSubBun') { return '새주소부번' } else if (code === 'dongNm') { return '동명칭' } else if (code === 'mainAtchGbCd') { return '주부속구분코드' } else if (code === 'mainAtchGbCdNm') { return '주부속구분코드명' } else if (code === 'platArea') { return '대지면적(㎡)' } else if (code === 'archArea') { return '건축면적(㎡)' } else if (code === 'bcRat') { return '건폐율(%)' } else if (code === 'totArea') { return '연면적(㎡)' } else if (code === 'vlRatEstmTotArea') { return '용적률산정연면적(㎡)' } else if (code === 'vlRat') { return '용적률(%)' } else if (code === 'strctCd') { return '구조코드' } else if (code === 'strctCdNm') { return '구조코드명' } else if (code === 'etcStrct') { return '기타구조' } else if (code === 'mainPurpsCd') { return '주용도코드' }
      return '코드미등록'
    },
     */
    // 건축물대장 층별개요 이름반환
    getStructureFloorCodeName (code) {
      if (code === 'rnum') { return '순번' } else if (code === 'platPlc') { return '대지위치' } else if (code === 'sigunguCd') { return '시군구코드' } else if (code === 'bjdongCd') { return '법정동코드' } else if (code === 'platGbCd') { return '대지구분코드' } else if (code === 'bun') { return '번' } else if (code === 'ji') { return '지' } else if (code === 'mgmBldrgstPk') { return '관리건축물대장PK' } else if (code === 'newPlatPlc') { return '도로명대지위치' } else if (code === 'bldNm') { return '건물명' } else if (code === 'splotNm') { return '특수지명' } else if (code === 'block') { return '블록' } else if (code === 'lot') { return '로트' } else if (code === 'naRoadCd') { return '새주소도로코드' } else if (code === 'naBjdongCd') { return '새주소법정동코드' } else if (code === 'naUgrndCd') { return '새주소지상지하코드' } else if (code === 'naMainBun') { return '새주소본번' } else if (code === 'naSubBun') { return '새주소부번' } else if (code === 'dongNm') { return '동명칭' } else if (code === 'flrGbCd') { return '층구분코드' } else if (code === 'flrGbCdNm') { return '층구분코드명' } else if (code === 'flrNo') { return '층번호' } else if (code === 'flrNoNm') { return '층번호명' } else if (code === 'strctCd') { return '구조코드' } else if (code === 'strctCdNm') { return '구조코드명' } else if (code === 'etcStrct') { return '기타구조' } else if (code === 'mainPurpsCd') { return '주용도코드' } else if (code === 'mainPurpsCdNm') { return '주용도코드명' } else if (code === 'etcPurps') { return '기타용도' } else if (code === 'mainAtchGbCd') { return '주부속구분코드' } else if (code === 'mainAtchGbCdNm') { return '주부속구분코드명' } else if (code === 'area') { return '면적(㎡)' } else if (code === 'areaExctYn') { return '면적제외여부' } else if (code === 'crtnDay') { return '생성일자' }
      return '코드미등록'
    },
    // 건축물대장 전유부 이름반환
    getStructureExposCodeName (code) {
      if (code === 'rnum') { return '순번' } else if (code === 'platPlc') { return '대지위치' } else if (code === 'sigunguCd') { return '시군구코드' } else if (code === 'bjdongCd') { return '법정동코드' } else if (code === 'platGbCd') { return '대지구분코드' } else if (code === 'bun') { return '번' } else if (code === 'ji') { return '지' } else if (code === 'mgmBldrgstPk') { return '관리건축물대장PK' } else if (code === 'regstrGbCd') { return '대장구분코드' } else if (code === 'regstrGbCdNm') { return '대장구분코드명' } else if (code === 'regstrKindCd') { return '대장종류코드' } else if (code === 'regstrKindCdNm') { return '대장종류코드명' } else if (code === 'newPlatPlc') { return '도로명대지위치' } else if (code === 'bldNm') { return '건물명' } else if (code === 'splotNm') { return '특수지명' } else if (code === 'block') { return '블록' } else if (code === 'lot') { return '로트' } else if (code === 'naRoadCd') { return '새주소도로코드' } else if (code === 'naBjdongCd') { return '새주소법정동코드' } else if (code === 'naUgrndCd') { return '새주소지상지하코드' } else if (code === 'naMainBun') { return '새주소본번' } else if (code === 'naSubBun') { return '새주소부번' } else if (code === 'dongNm') { return '동명칭' } else if (code === 'hoNm') { return '호명칭' } else if (code === 'flrGbCd') { return '층구분코드' } else if (code === 'flrGbCdNm') { return '층구분코드명' } else if (code === 'flrNo') { return '층번호' } else if (code === 'crtnDay') { return '생성일자' }
      return '코드미등록'
    },
    //
    urlCopy () {
      this.$utile.copyToClipboard(window.location.href)
      EventBus.$emit('alert', '링크가 클립보드로 복사되었습니다.')
    },
    urlShare () {
      let addr = this.mapData.detailView.data.addr
      if (addr) {
        let addrarray = this.mapData.detailView.data.addr.split(' ')
        addr = addrarray[0] + ' ' + addrarray[1] + ' ' + addrarray[2]
      }
      if (this.mapData.detailView.type === 'r') {
        this.Kakao.Link.sendDefault({
          objectType: 'feed',
          content: {
            title: `[${this.config.site.name}] ${addr}`,
            description: this.mapData.detailView.data.itemType + '(' + this.mapData.detailView.data.struct + '), ' + this.mapData.detailView.data.price,
            imageUrl: this.mapData.detailView.data.title_img_url,
            link: {
              mobileWebUrl: window.location.href,
              webUrl: window.location.href
            }
          }
        })
      } else if (this.mapData.detailView.type === 'b') {
        this.Kakao.Link.sendDefault({
          objectType: 'feed',
          content: {
            title: `[${this.config.site.name}] ${addr}`,
            description: this.mapData.detailView.data.name,
            imageUrl: this.mapData.detailView.data.title_img_url,
            link: {
              mobileWebUrl: window.location.href,
              webUrl: window.location.href
            }
          }
        })
      }
    },
    downOriImg (savename) {
      downloadObjectAsZip('ori', savename, this.mapData.detailView.data.img_ori_down_url)
    },
    downThumbImg (savename) {
      downloadObjectAsZip('thumb', savename, this.mapData.detailView.data.img_thumb_down_url)
    },
    findRoom (no) {
      EventBus.$emit('findRoom', no)
    },
    callcenter () { // 전화상담
      if (Utile.isMobile()) { // 모바일
        document.location.href = 'tel:' + this.config.company.customerNumber
      } else { // 데스크탑
        // this.$router.push('customer') 고객센터 페이지 이동
        this.telInfoDialog = true
      }
    },
    showModifView (type, url) {
      this.mapData.modifView.type = type
      this.mapData.modifView.src = url
      this.mapData.modifView.show = true
    },
    getItemClass (item) {
      if (item.live === '1') {
        return 'live'
      } else if (item.visible === '1') {
        return 'visible'
      }
      return 'non'
    },
    printTotalFloor () {
      return `${((this.mapData.detailView.data.under_floor * 1) > 0) ? '지하 ' + this.mapData.detailView.data.under_floor : '지상 1'}층 ~ 지상 ${this.mapData.detailView.data.floor}층`
    },
    drowPolygon () {
      this.$refs.minimap.removeCustomOverlay('Point')
      /*
      if (this.map.polygon != null) {
        this.map.polygon.setMap(null)
      }
      */
      if (this.map.mapObject != null) {
        if (this.auth.isStaff || this.auth.isPlusMember || this.auth.isPartner) { // 직원 플러스회원
          const position = this.mapData.detailView.data.position

          let content = document.createElement('div')
          content.className = 'minimap-overlay-point'
          content.innerHTML = `<div><div class="img"><svg x="0px" y="0px" width="47.8px" height="50px" viewBox="0 0 47.8 50" >
<polygon class="svg-building-bg" points="3.8,1.1 32.9,1.1 32.9,14 44.1,14 44.1,49 3.8,49 "/>
<g>
\t<path class="svg-building-line" d="M45.4,47.8V15.2V13h-2.2h-9V0H2.6v47.8H0V50h47.8v-2.2H45.4z M21,47.8h-5.2V39H21V47.8z M32,47.8h-8.8v-11h-9.6v11H4.8V2.2H32V47.8z M34.2,15.2h9v32.7h-9V15.2z"/>
\t<rect x="9.2" y="7.4" class="svg-building-line" width="7.4" height="2.2"/>
\t<rect x="9.2" y="18.4" class="svg-building-line" width="7.4" height="2.2"/>
\t<rect x="20.2" y="7.4" class="svg-building-line" width="7.4" height="2.2"/>
\t<rect x="20.2" y="18.4" class="svg-building-line" width="7.4" height="2.2"/>
\t<rect x="9.2" y="29.4" class="svg-building-line" width="7.4" height="2.2"/>
\t<rect x="20.2" y="29.4" class="svg-building-line" width="7.4" height="2.2"/>
</g></svg></div><div class="info-text">${((position.name === '') ? '미지정' : position.name)}</div></div>`
          let _position = this.$refs.minimap.newLatLng(position.lat, position.lng)
          this.$refs.minimap.addCustomOverlay('Point', { // let overlay =
            position: _position,
            zIndex: 4,
            content: content
          }, content, () => { // 클릭
          })
          this.map.mapObject.setLevel(3)
          this.map.mapObject.setCenter(_position)
        } else { // 일반
          let position = this.mapData.detailView.data.position
          // console.log('드로우', position)
          let path = []
          path.push(this.$refs.minimap.newLatLng(position.startLat, position.startLng))
          path.push(this.$refs.minimap.newLatLng(position.startLat, position.endLng))
          path.push(this.$refs.minimap.newLatLng(position.endLat, position.endLng))
          path.push(this.$refs.minimap.newLatLng(position.endLat, position.startLng))
          this.map.polygon.setPath(path)

          const _latlng = this.$refs.minimap.newLatLng(position.centerLat, position.centerLng)
          this.map.mapObject.setLevel(3)
          this.map.mapObject.setCenter(_latlng)
        }
      }
    },
    /* 맵 온로드 */
    onLoad (map) {
      console.log('미니 맵로드')
      this.map.mapObject = map
      // 초기셋팅
      this.initMap()
    },
    /* 맵 이벤트 */
    onMapEvent (event, params) {
      // console.log(`Daum Map Event(${event})`, params) // 이벤트 로그
      if (event === 'click') { // 클릭 이벤트
        if (this.map.mapTypeId === MiniMap.MapTypeId.ROADVIEW) { // 로드뷰라면
          var latlng = params[0].latLng
          var roadviewContainer = document.getElementById('mini_roadview_area')
          this.$refs.minimap.showRoadView(latlng, roadviewContainer)
          this.map.roadviewArea = true
        }
      }
      if (event === 'zoom_changed') { // 줌 변형
        this.center = this.map.mapObject.getCenter()
        this.level = this.map.mapObject.getLevel()
      } else if (event === 'dragend') { // 맵 드래그
        this.center = this.map.mapObject.getCenter()
        this.updateMap()
      } else if (event === 'idle') { // 휴식일때 처리
        // if (this.mapView.updateState) {
        // this.updateMap()
        // }
      }
    },
    initMap () {
      this.map.polygon = this.$refs.minimap.newPolygon({
        strokeWeight: 2, // 선의 두께입니다
        strokeColor: '#0056e6', // 선의 색깔입니다
        strokeOpacity: 0.4, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
        strokeStyle: 'solid', // 선의 스타일입니다
        fillColor: '#0056e6', // 채우기 색깔입니다
        fillOpacity: 0.1, // 채우기 불투명도입니다
        zIndex: 2
      })
      this.map.polygon.setMap(this.map.mapObject)
      this.drowPolygon()
    },
    updateMap () {
      //
    },
    setOverlayMapTypeId (maptype) {
      this.$refs.minimap.setOverlayMapTypeId(maptype)
    },
    getStaticUrl () {
      return Utile.getStaticUrl()
    },
    close () {
      this.$router.replace('map')
    },
    dragStart (e) {
      if (!Utile.isMobile()) {
        this.drag = true
        this.viewElement = document.getElementById('map_detail_view')
        this.initialX = e.clientX - this.xOffset
        this.initialY = e.clientY - this.yOffset
        window.addEventListener('mousemove', this.dragging, false)
        window.addEventListener('mouseup', this.dragEnd, false)
      }
    },
    dragEnd (e) {
      if (!Utile.isMobile()) {
        this.drag = false
        window.removeEventListener('mousemove', this.dragging, false)
        window.removeEventListener('mouseup', this.dragEnd, false)
      }
    },
    dragging (e) {
      if (this.drag) {
        this.currentX = e.clientX - this.initialX
        this.currentY = e.clientY - this.initialY

        this.xOffset = this.currentX
        this.yOffset = this.currentY
        // this.viewElement.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`
        this.top = this.currentY + 'px'
        this.left = this.currentX + 'px'
      }
    },
    onResize () {
      if (document.getElementById('map_detail_view') != null) {
        if (this.top === 0) {
          let top = (window.innerHeight / 2) - (document.getElementById('map_detail_view').clientHeight / 2)
          let left = (window.innerWidth / 2)
          this.top = top + 'px'
          this.left = left + 'px'
          this.xOffset = left
          this.yOffset = top
        }
        // 슬라이드
        this.carouselHeight = (document.getElementById('map_detail_view').clientWidth / 16) * 10 // 슬라이더 비율조정
      }
      /*
        const viewElement = document.getElementById('map_detail_view')
        const minSize = 800
        if (window.innerWidth > 960) { // 데스크탑
          viewElement.style.width = `${minSize}px`
          viewElement.style.left = `50%`
          viewElement.style.top = `0`
          viewElement.style.marginLeft = `-${minSize / 2}px`
        } else { // 모바일
          viewElement.style.width = `100%`
          viewElement.style.height = `100%`
          viewElement.style.left = `0`
          viewElement.style.top = `0`
          viewElement.style.style.marginLeft = `0`
        }
        */
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modal/map/DetailView.vue